export default { sha: '5c73644428a2d7a5b6aa96f48dd039442cd0e9e2', buildNumber: 'undefined' }
